export default __webpack_public_path__ + "static/alley-e2b3e663aeb661b1552e23850bcc8564.jpg";